"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreator = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var bannerClick_1 = require("./bannerClick");
var bannerImpression_1 = require("./bannerImpression");
var creatorMappings = (_a = {},
    _a[analytics_layer_1.BannerEventNames.BannerClick] = bannerClick_1.bannerClick,
    _a[analytics_layer_1.BannerEventNames.BannerImpression] = bannerImpression_1.bannerImpression,
    _a);
var getCreator = function (eventName) { return creatorMappings[eventName]; };
exports.getCreator = getCreator;
